import _ from "lodash";
import {
    FETCH_FEED,
    MODIFY_FEED,
    TOGGLE_LIKE,
    FETCH_SINGLE_FEED,
} from "./Feed.action.react";
import { REHYDRATE } from "redux-persist/constants";

const initialFeedState = {
    posts: [],
    post: {},
    fetchCompleted: false,
    error: null,
};

const FeedReducer = (state = initialFeedState, action) => {
    switch (action.type) {
        case REHYDRATE:
            let feed = action.payload.feed;
            if (feed) {
                return { ...state, ...feed };
            } else {
                return state;
            }
        case FETCH_FEED:
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                return { posts: action.data.posts };
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case FETCH_SINGLE_FEED:
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                return _.merge({}, state, action.data, {
                    fetchCompleted: true,
                    error: null,
                });
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case MODIFY_FEED:
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                return _.merge({}, action.data, {
                    fetchCompleted: true,
                    error: null,
                });
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case TOGGLE_LIKE:
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                let id = action.data.id;
                _.replace(
                    state["posts"],
                    _.findIndex(state["posts"], { id: id }),
                    action.data
                );
                if (!_.isEmpty(state["post"]) && state["post"]["id"] === id)
                    return {
                        ...state,
                        post: action.data,
                        fetchCompleted: true,
                        error: null,
                    };
                else return { ...state, fetchCompleted: true, error: null };
            } else {
                return { ...state, error: action.err };
            }
        default:
            return state;
    }
};

export { FeedReducer };
